import React from 'react';

import { useTranslation } from '@modernloop/i18n';
import { CircleWithCheckIcon } from '@modernloop/shared/icons';
import { Button, CircularProgress, Stack, Tooltip, Typography } from '@mui/material';

import ImportIllustration from 'src/assets/images/import_availability_300_150.png';

interface Props {
  importingAvailability: boolean;
  importComplete: boolean;
  importAvailabilities: () => void;
  clearWarnings: () => void;
  candidateTimezone?: string;
  showSmallButton?: boolean;
}

export const ImportAvailabilityButton: React.FC<Props> = ({
  importingAvailability,
  importComplete,
  importAvailabilities,
  clearWarnings,
  candidateTimezone,
  showSmallButton = false,
}) => {
  const { t } = useTranslation();
  const importButtonDecoration = () => {
    if (importingAvailability) {
      return <CircularProgress size={20} />;
    }
    if (importComplete) {
      return <CircleWithCheckIcon color="success" />;
    }
    return null;
  };

  return (
    <Tooltip
      disableInteractive
      sx={{ display: 'flex' }}
      title={
        <Stack justifyContent="center" alignContent="center" textAlign="center">
          <img src={ImportIllustration} alt={t('hiring-dashboard-common:common.availability.importAlt')} />
          <Typography>{t('hiring-dashboard-common:common.availability.importTooltip')}</Typography>
        </Stack>
      }
    >
      <Button
        startIcon={importButtonDecoration()}
        disabled={importingAvailability || !candidateTimezone}
        sx={{
          alignSelf: 'start',
        }}
        fullWidth={false}
        onClick={() => {
          clearWarnings();
          importAvailabilities();
        }}
        size={showSmallButton ? 'small' : 'medium'}
      >
        {t('hiring-dashboard-common:common.availability.importButton')}
      </Button>
    </Tooltip>
  );
};
